import { render, staticRenderFns } from "./usus.vue?vue&type=template&id=e5f8cb52&"
import script from "./usus.vue?vue&type=script&lang=js&"
export * from "./usus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports